/**
 * @author: Ujjwal Jain
 * @file: ideas.js
 *
 * @copyright: KNOLSKAPE Solutions Pvt Ltd
 **/

import Immutable from 'immutable';
import actionConsts from 'constants/actions';
import { mergeListsBasedOnKey, setOrUpdateObjectInList } from 'util/objectUtils';

const initialState = Immutable.fromJS({
    userEventsList: []
});

const UserEvents = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.get('SET_USER_EVENTS'):
            return state.set('userEventsList', mergeListsBasedOnKey(state.get('userEventsList'), action.payload, 'eventId'));
        case actionConsts.get('UPDATE_USER_EVENTS'):
            return state.set('userEventsList', mergeListsBasedOnKey(state.get('userEventsList'), action.payload, 'eventId'));
        default:
            return state;
    }
};

export default UserEvents;